/**
 * Check if the screen is in portrait mode (e.g. smartphones)
 *
 * @return {Boolean}
 */
export default () => (window.innerHeight / window.innerWidth) > 1;
